// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"co_a bhv_a bhv_w","Messages__hasSeen":"co_b bhv_p"};